module.exports = __webpack_public_path__ + "static/media/Temitope Akinsoto_HackerRank.4d07d2cf.pdf";